export default{
  data(){
    return {
      data: {}
    }
  },
  created(){
    let obj = localStorage.getItem("risk_detail_data");
    try {
      obj = JSON.parse(obj);
      if (obj != null) this.data = obj;
    } catch (e) {}
  }
}